define("shared/components/shared/ui/switcher/option", ["exports", "@ember/component", "@ember/component/template-only", "@ember/template-factory"], function (_exports, _component, _templateOnly, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/component/template-only",0,"@ember/component"eaimeta@70e063a35619d71f
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <Shared::Ui::Button
    @additional="block"
    @onClick={{@onClick}}
    @variant="unstyled"
    class="o--user u--flex u--flex__alignItems--center"
    data-qa-id={{@qaId}}
    ...attributes
  >
    <span class="o--user__avatarProfile">
      {{#if @loading}}
        <Shared::LoadingSpinner @additionalClass="o--user__avatar u--p__t u--p__l__lg" />
      {{else if (eq @option.avatar.type "image")}}
        <img
          alt={{@option.label}}
          class={{concat-classes "o--user__avatar" (or @option.avatar.className "")}}
          draggable="false"
          ondragstart="return false;"
          src={{@option.avatar.value}}
        />
      {{else}}
        <span
          class={{concat-classes
            "o--user__avatar"
            "u--flex"
            "u--flex__alignItems--center"
            "u--flex__justify--center"
            (or @option.avatar.className "")
          }}
        >
          {{#if @option.avatar.value}}
            {{svg-jar @option.avatar.value class="o--icon--md o--icon--light"}}
          {{/if}}
        </span>
      {{/if}}
    </span>
    <span class={{if @option.caption "u--flex u--flex__col u--flex__alignItems--start"}}>
      <span class="o--user__title" data-test-id="label">
        <span class="u--ellipsis">
          {{@option.label}}
        </span>
      </span>
      {{#if @option.caption}}
        <span class="o--user__desc" data-test-id="caption">
          {{@option.caption}}
        </span>
      {{/if}}
    </span>
  </Shared::Ui::Button>
  */
  {
    "id": "A6pUMVO7",
    "block": "[[[8,[39,0],[[24,0,\"o--user u--flex u--flex__alignItems--center\"],[16,\"data-qa-id\",[30,1]],[17,2]],[[\"@additional\",\"@onClick\",\"@variant\"],[\"block\",[30,3],\"unstyled\"]],[[\"default\"],[[[[1,\"\\n  \"],[10,1],[14,0,\"o--user__avatarProfile\"],[12],[1,\"\\n\"],[41,[30,4],[[[1,\"      \"],[8,[39,2],null,[[\"@additionalClass\"],[\"o--user__avatar u--p__t u--p__l__lg\"]],null],[1,\"\\n\"]],[]],[[[41,[28,[37,3],[[30,5,[\"avatar\",\"type\"]],\"image\"],null],[[[1,\"      \"],[10,\"img\"],[15,\"alt\",[30,5,[\"label\"]]],[15,0,[28,[37,4],[\"o--user__avatar\",[28,[37,5],[[30,5,[\"avatar\",\"className\"]],\"\"],null]],null]],[14,\"draggable\",\"false\"],[14,\"ondragstart\",\"return false;\"],[15,\"src\",[30,5,[\"avatar\",\"value\"]]],[12],[13],[1,\"\\n\"]],[]],[[[1,\"      \"],[10,1],[15,0,[28,[37,4],[\"o--user__avatar\",\"u--flex\",\"u--flex__alignItems--center\",\"u--flex__justify--center\",[28,[37,5],[[30,5,[\"avatar\",\"className\"]],\"\"],null]],null]],[12],[1,\"\\n\"],[41,[30,5,[\"avatar\",\"value\"]],[[[1,\"          \"],[1,[28,[35,6],[[30,5,[\"avatar\",\"value\"]]],[[\"class\"],[\"o--icon--md o--icon--light\"]]]],[1,\"\\n\"]],[]],null],[1,\"      \"],[13],[1,\"\\n    \"]],[]]]],[]]],[1,\"  \"],[13],[1,\"\\n  \"],[10,1],[15,0,[52,[30,5,[\"caption\"]],\"u--flex u--flex__col u--flex__alignItems--start\"]],[12],[1,\"\\n    \"],[10,1],[14,0,\"o--user__title\"],[14,\"data-test-id\",\"label\"],[12],[1,\"\\n      \"],[10,1],[14,0,\"u--ellipsis\"],[12],[1,\"\\n        \"],[1,[30,5,[\"label\"]]],[1,\"\\n      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n\"],[41,[30,5,[\"caption\"]],[[[1,\"      \"],[10,1],[14,0,\"o--user__desc\"],[14,\"data-test-id\",\"caption\"],[12],[1,\"\\n        \"],[1,[30,5,[\"caption\"]]],[1,\"\\n      \"],[13],[1,\"\\n\"]],[]],null],[1,\"  \"],[13],[1,\"\\n\"]],[]]]]]],[\"@qaId\",\"&attrs\",\"@onClick\",\"@loading\",\"@option\"],false,[\"shared/ui/button\",\"if\",\"shared/loading-spinner\",\"eq\",\"concat-classes\",\"or\",\"svg-jar\"]]",
    "moduleName": "shared/components/shared/ui/switcher/option.hbs",
    "isStrictMode": false
  });
  var _default = _exports.default = (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, (0, _templateOnly.default)());
});